<template>
  <b-row>
    <b-col cols="12" class="container min-vh-100">
      <b-row>
        <b-card class="w-100 h-100">
          <b-row
            v-for="item in sortMenu()"
            :key="item.menuId"
            :class="item.menuLevel === 0 ? 'pt-2' : ''"
          >
            <b-col v-if="item.menuLevel === 0" cols="12" md="10">
              <h3 class="" style="padding-left: 10px;">{{ item.name }}</h3>
            </b-col>
            <b-col v-else-if="item.menuLevel === 1" cols="12" md="10">
              <span class="" style="padding-left: 30px;">{{ item.name }}</span>
            </b-col>
            <b-col v-else-if="item.menuLevel === 2" cols="12" md="10">
              <span class="" style="padding-left: 50px;">{{ item.name }}</span>
            </b-col>
            <b-col v-else cols="12" md="10">
              <span class="" style="padding-left: 70px;">{{ item.name }}</span>
            </b-col>

            <b-col cols="12" md="2" class="">
              <b-form-group>
                <!-- <b-form-radio-group
                  v-model="item.status"
                  :options="activeOptions"
                  @change="onPermissionChange(item.status, item)"
                ></b-form-radio-group> -->
                <b-form-checkbox
                  v-bind:value="2"
                  v-model="item.status"
                  class="custom-control-primary"
                  @change="onPermissionChange(item.status, item)"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="XIcon" />
                  </span>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <b-col cols="12" class="d-flex justify-content-between pt-2">
            <b-button variant="secondary" @click="onCancelBtnClicked">
              ยกเลิก
            </b-button>
            <b-button variant="primary" @click="onSubmitBtnClicked">
              บันทึกข้อมูล
            </b-button>
          </b-col>
        </b-card>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BFormInput,
  BFormGroup,
  BFormRadioGroup,
  BFormCheckbox,
} from "bootstrap-vue";

import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";

import * as roleStore from "@/store/api/role/index.js";
import * as userData from "@/auth/localStorageUtils.js";

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
    BFormCheckbox,
  },
  data() {
    return {
      roleId: null,
      menus: [],
      activeOptions: [
        { text: "มีสิทธิ์", value: 2 },
        { text: "ไม่มีสิทธิ์", value: 0 },
      ],
    };
  },
  created() {
    const _this = this;
    if (this.$route.query.id == null) {
    } else {
      const id = this.$route.query.id;
      this.roleId = id;
      this.getMenu(id);
    }
  },
  mounted() {
    this.setBreadcrumb();
  },
  methods: {
    setBreadcrumb() {
      const _this = this;

      roleStore
        .getById(_this.$route.query.id)
        .then((response) => {
          const roleData = response.data.data;

          console.log("route name", this.$route.meta);
          _this.$route.meta.breadcrumb[2].text = roleData.roleName;

          // Add a temporary query parameter.
          _this.$router.replace({
            query: { temp: Date.now(), id: _this.$route.query.id },
          });
          // Remove the temporary query parameter.
          _this.$router.replace({
            query: { temp: undefined, id: _this.$route.query.id },
          });
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getMenu(id) {
      const _this = this;

      roleStore
        .getMenu(id)
        .then((response) => {
          _this.menus = response.data.data;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    sortMenu() {
      const _this = this;

      let sortedMenu = [];

      const menuLevel0 = this.menus
        .filter((value) => value.menuLevel === 0)
        .sort((a, b) => Number(a.sequence) - Number(b.sequence));

      let order = 0;

      menuLevel0.forEach((value) => {
        value.marginLeft = 1;
        value.order = order++;
        sortedMenu.push(value);

        const child = _this.sortMenuRecursive(value, sortedMenu, order);

        if (child !== null) {
          //sortedMenu.push(...child);
        }
      });

      //console.log("sortedMenu", sortedMenu, menuLevel0);

      return sortedMenu;
    },
    sortMenuRecursive(menu, sortedMenu, order) {
      //console.log("sortMenuRecursive", menu);

      const _this = this;
      const childMenus = this.menus
        .filter((value) => value.parent === menu.menuId)
        .sort((a, b) => Number(a.sequence) - Number(b.sequence));

      //console.log("sortMenuRecursive childMenus", childMenus);

      if (childMenus.length == 0) return null;

      childMenus.forEach((value) => {
        value.marginLeft = value.menuLevel + 1;
        value.order = order++;
        sortedMenu.push(value);

        const child = _this.sortMenuRecursive(value, sortedMenu, order);

        if (child !== null) {
          //sortedMenu.push(...child);
        }
      });

      return childMenus;
    },
    onPermissionChange(status, menu) {
      console.log("status=", status, "menuId=", menu.menuId);

      if (status === 2) {
        this.setParentPermission(status, menu.parent);
      } else {
        this.setChildPermission(status, menu.menuId);
      }
    },
    setChildPermission(status, menuId) {
      const _this = this;

      console.log("setChildPermission status=", status, "menuId=", menuId);

      const childMenus = this.menus
        .filter((value) => value.parent === menuId)
        .sort((a, b) => Number(a.sequence) - Number(b.sequence));

      childMenus.forEach((value) => {
        console.log("value", value.menuId);
        value.status = status;

        _this.setChildPermission(status, value.menuId);
      });
    },
    setParentPermission(status, parent) {
      const _this = this;

      console.log("setParentPermission status=", status, "parent=", parent);

      const parentMenu = this.menus.find((value) => {
        return value.menuId === parent;
      });

      if (parentMenu !== null && parentMenu !== undefined) {
        parentMenu.status = status;

        _this.setParentPermission(status, parentMenu.parent);
      }
    },
    onSubmitBtnClicked() {
      const _this = this;

      this.$swal({
        title: "ยืนยันการบันทึกข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const validMenus = _this.menus.map((value) => {
            if (value.status !== 2) {
              value.status = 0;
            }

            return value;
          });

          const params = {
            menus: validMenus,
            roleId: _this.roleId,
          };

          roleStore
            .updateRoleMenu(params)
            .then((response) => {
              if (response.data.success === true) {
                _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                  variant: "success",
                  solid: false,
                });
                window.open(
                  _this.$router.resolve({
                    name: "role",
                  }).href,
                  "_self"
                );
              } else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                variant: "danger",
                solid: false,
              });
            });
        }
      });
    },
    onCancelBtnClicked() {
      window.open(this.$router.resolve({ name: "role" }).href, "_self");
    },
  },
};
</script>

<style lang="scss"></style>
